import React from 'react';
import { getStatsCollectionRoot, isStatsSandbox } from '../utils/teamStatsConfig';

/**
 * Small banner when local/dev is writing to the stats sandbox (not production Live/Gazette).
 */
export default function StatsSandboxBanner() {
  if (!isStatsSandbox()) return null;
  return (
    <div
      role="status"
      style={{
        background: 'linear-gradient(90deg, #0d4f54 0%, #006d75 100%)',
        color: '#e6e8ec',
        fontSize: '0.8rem',
        padding: '0.35rem 0.75rem',
        textAlign: 'center',
        borderBottom: '1px solid rgba(255,255,255,0.12)',
      }}
    >
      Stats sandbox: local data is stored under <strong>{getStatsCollectionRoot()}/</strong> and will not
      appear on the production site. Production builds use <strong>stats/</strong>.
    </div>
  );
}
